import smartSolveApi from './instances/smartsolve';
import { submitMasterSetupRecord } from './submit-master-setup-record';

export const getDashboardConfig = async (actorCode = 'DEFAULT-DASHBOARD') => {
  try {
    const response = await smartSolveApi.post('/getentitydata', {
      entityType: 'PER_PERSONALIZATION',
      itmId: '',
      formStyle: 'ClientEnableForm',
      entityName: 'PER_PERSONALIZATION',
      formEntityKey: '',
      workflowId: '',
      parentWorkflowId: '',
      stepId: '',
      containerWorkflowKey: '',
      workflowKey: '',
      userKey: actorCode,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getDashboardConfig() failed: ${e}`);
  }
};

export const insertDashboardConfig = async (newConfig, actorCode) => {
  try {
    const clientChanges = [
      {
        dataMember: 'V_PER_PERSONALIZATION',
        rows: [
          {
            rowid: 'NR_1',
            state: 'ADDED',
            fields: [
              {
                columnName: 'PK_ID',
                currentValue: 'NR_1',
              },
              {
                columnName: 'CODE',
                currentValue: actorCode,
              },
              {
                columnName: 'PER_DASHBOARD_OPTIONS',
                currentValue: newConfig,
              },
              {
                columnName: 'IsNewObject',
                currentValue: true,
              },
              {
                columnName: 'IsExistingObject',
                currentValue: false,
              },
            ],
          },
        ],
      },
    ];

    const data = await submitMasterSetupRecord({
      entityName: 'PER_PERSONALIZATION',
      itemCode: actorCode,
      itemId: '',
      clientChanges,
    });

    return data;
  } catch (e) {
    throw new Error(`insertDashboardConfig() failed: ${e}`);
  }
};

const updateDashboardConfig = async (prevConfig, newConfig, actorCode, rowId) => {
  try {
    const clientChanges = [
      {
        dataMember: 'V_PER_PERSONALIZATION',
        rows: [
          {
            rowid: rowId,
            state: 'MODIFIED',
            modifiedDateColumnName: 'MODIFIED_DATE',
            fields: [
              {
                columnName: 'PER_DASHBOARD_OPTIONS',
                originalValue: prevConfig,
                currentValue: newConfig,
              },
            ],
          },
        ],
      },
    ];

    const data = await submitMasterSetupRecord({
      entityName: 'PER_PERSONALIZATION',
      itemCode: actorCode,
      itemID: '',
      clientChanges,
    });

    return data;
  } catch (e) {
    throw new Error(`updateDashboardConfig() failed: ${e}`);
  }
};

export const saveDashboardConfig = async (prevConfig, newConfig, actorCode, code, rowId) => {
  try {
    if (code.toUpperCase() !== actorCode) {
      return await insertDashboardConfig(newConfig, actorCode);
    }

    return await updateDashboardConfig(prevConfig, newConfig, actorCode, rowId);
  } catch (e) {
    throw new Error(`saveDashboardConfig() failed: ${e}`);
  }
};

export const deleteDashboardConfig = async (actorCode) => {
  try {
    const data = await submitMasterSetupRecord({
      entityName: 'PER_PERSONALIZATION',
      itemCode: actorCode,
      itemId: '',
      clientChanges: [],
      isDelete: true,
    });

    return data;
  } catch (e) {
    throw new Error(`deleteDashboardConfig() failed: ${e}`);
  }
};
